import { useContext, useLayoutEffect, useState } from "react";
import { useSelector } from "react-redux";

import { Logos } from "Images";
import { selectActualTheme } from "Store/Selectors/UI";
import { getImageAsBase64 } from "API/Image";
import { isNotNullOrWhiteSpace } from "Utils/String";
import { ConfigurationContext } from "../Components/Generic/Configuration";

export function useLogo(): string {
  const themeType = useSelector(selectActualTheme);
  const config = useContext(ConfigurationContext);
  const [logo, setLogo] = useState(Logos(`ORBIS_${themeType}`));

  useLayoutEffect(() => {
    if (!config.hasCustomLogo()) {
      setLogo(Logos(`ORBIS_${themeType}`));
      return;
    }

    (async function generate() {
      let logoSrc = null;

      const base64Path = config.getLogoPath(themeType);
      if (isNotNullOrWhiteSpace(base64Path)) {
        logoSrc = await getImageAsBase64(base64Path, config.getLogoDataType());
      }

      if (logoSrc == null) {
        console.warn(
          `\t\t⚠️ "environment.logo.isCustom: true" is configured but no logo file was found for theme ${themeType}.\r\nCheck deployment configuration and provide logos for both theme variants.\r\nFalling back to ORBIS SE logo.\r\n\r\n`
        );
        return;
      }

      setLogo(logoSrc);
    }());
  }, [config, themeType]);

  return logo;
}
